import { useEffect, useState } from 'react';

import { blogContentId } from '@/cms/CMSBlogLayout';
import { getHasGateBeenCleared } from './utils';

const useGatedContentStyleHack = ({ gateId }: { gateId: string }) => {
  const [hasApplied, setHasApplied] = useState(false);

  useEffect(() => {
    if (hasApplied) return;

    const blogContentContainer = document.querySelector(`#${blogContentId}`);
    if (!blogContentContainer) return;

    if (getHasGateBeenCleared(gateId)) return;

    let foundGate = false;

    for (let i = 0; i < blogContentContainer.children.length; i++) {
      const child = blogContentContainer.children[i];

      if (foundGate) {
        child.classList.add('hide-content');
      }
      if (child.id === gateId) {
        foundGate = true;
      }
    }

    setHasApplied(true);
  }, [gateId, hasApplied, setHasApplied, getHasGateBeenCleared]);

  return { hasApplied };
};

export default useGatedContentStyleHack;
